module.exports = __webpack_public_path__ + "static/media/codeBallSounds.703b8e9b.jpg";